import cloneDeep from 'lodash/cloneDeep'
import Vue from 'vue'

const initState = {
    init:false,
}
export default {
    state: cloneDeep(initState),
    mutations: {
        globalParamsResetStore(state){
            console.log('初始化globalParams')
            if(window.vm.$store.state){
                Vue.set(window.vm.$store.state,'globalParams',cloneDeep(initState))
            }
        },
        updateGlobalParams(state, valObj) {
            console.log('更新globalParams',valObj)
            for (let key in valObj) {
                Vue.set(state,key,valObj[key])
            }
        },
    },
    actions: {},
    getters: {}
}
